import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// components
import { AlertMessage } from '../../components';
import { getFormattedPlanName } from '../../helpers/plansHelper';
// redux
import { getUser, getVideosPerMonthLimit, getMediaTtl } from '../../redux/modules/auth';
import { getIsVideoCollectionExpired } from '../../redux/modules/media';
import { getSelectedOrganization, getIsContextChanging } from '../../redux/modules/organization';
// helpers
import { getMediaMonthlyLimitAlertHeaderVerbiage } from '../../helpers/planUpgradeVerbiage';

const MediaListAlertMessage = ({
  isVideoCollectionExpired = false,
  mediaTtl = 0,
  organization = {},
  user = {},
  videosPerMonthLimit = 0,
  isContextChanging,
}) => {
  const currentPlan = getFormattedPlanName(user, organization);
  const title = `You have reached the limits of our ${currentPlan} plan.`;
  const description = getMediaMonthlyLimitAlertHeaderVerbiage({ currentPlan, videosPerMonthLimit, mediaTtl });

  if (!isVideoCollectionExpired || isContextChanging) {
    return null;
  }

  return (
    <AlertMessage data-testid="mediaListAlertMessageContainer" icon="exclamation-triangle" title={title} description={description} type="warning" isHeaderMessage />
  )
};

MediaListAlertMessage.propTypes = {
  user: PropTypes.object,
  organization: PropTypes.object,
  videosPerMonthLimit: PropTypes.number,
  mediaTtl: PropTypes.number,
  videosCollectedThisMonth: PropTypes.number,
  isVideoCollectionExpired: PropTypes.bool,
};

const mapStateToProps = state => ({
  isVideoCollectionExpired: getIsVideoCollectionExpired(state),
  mediaTtl: getMediaTtl(state),
  organization: getSelectedOrganization(state),
  isContextChanging: getIsContextChanging(state),
  user: getUser(state),
  videosPerMonthLimit: getVideosPerMonthLimit(state),
})

export default connect(mapStateToProps)(MediaListAlertMessage);



// WEBPACK FOOTER //
// ./src/components/MediaListAlertMessage/MediaListAlertMessage.jsx